import { Box, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { UBButton } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { useAuthContext } from "../../../../context/AuthContext";
import {
  InnerWrapper,
  MainContainer,
  PINScreen,
  TitleAndActionBox,
} from "../../../common";
import BusinessLoader from "../../../common/BusinessLoader";
import NonIdealNew from "../../../common/NonIdealNew";
import { SetupPIn } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { handleApi } from "../../../../apis";
import { CHECK_PIN_GET, SET_PIN_GET } from "../../../../apis/configuration";
import CreatePin from "./CreatePin";
import ActivatedPinCode from "./ActivatedPinCode";
import SuccessfullyUpdatePin from "./SuccessfullyUpdatePin";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import styles from "./styles.module.css";
const SetupPin = () => {
  const [I18n] = useContext(LanguageContext);
  const { handleLogoutInDB } = useAuthContext();
  const navigate = useNavigate();
  const [isCreate, setIsCreate] = useState(false);
  const [verifyPINScreen, setVerifyPINScreen] = useState(false);
  const [isAcivatedScreen, setIsActivatedScreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkPINloading, setCheckPINLoading] = useState(false);
  const [PIN, setPIN] = useState("");
  const [error, setError] = useState("");
  const [errorCheckPin, setErrorCheckPin] = useState(true);
  const [isPinUpdatedSuccessfully, setIsPinUpdatedSuccessfully] =
    useState(false);
  const [accountLockedModal, setAccountLockedModal] = useState(false);
  const [lockedResponse, setLockedResponse] = useState(null);
  useEffect(() => {
    handleCheckIsSetPin();
    triggerLogEvent(analytics, "setting_pin");
  }, []);

  const cancelCreatePin = () => {
    handleCheckIsSetPin();
    triggerLogEvent(analytics, "setting_pin_cancel", {});
  };

  const handleCheckIsSetPin = async () => {
    setCheckPINLoading(true);
    try {
      const res = await handleApi(SET_PIN_GET, null, null, navigate);

      if (res?.success) {
        setIsActivatedScreen(res?.pin_set);
        setCheckPINLoading(false);
        setErrorCheckPin(false);
        setIsCreate(false);
        triggerLogEvent(analytics, "setting_pin_save", {});
        setError("");
      } else {
        setCheckPINLoading(false);
        setErrorCheckPin(false);
      }
    } catch {
      setCheckPINLoading(false);
      setErrorCheckPin(true);
    }
  };

  const getPIN = async (pin) => {
    const tempPhone = localStorage.getItem("phone_number");
    try {
      setError("");
      setLoading(true);
      const response = await handleApi(CHECK_PIN_GET, { pin }, null, navigate, {
        "Web-Token": Cookies.get("deviceId"),
      });
      if (response.success) {
        setPIN(pin);
        setIsActivatedScreen(false);
        setVerifyPINScreen(false);
        setIsCreate(true);
        setLoading(false);
      } else {
        setLoading(false);
        const isLocked =
          response?.is_locked ||
          response?.account_status === "locked" ||
          response?.account_status === "suspended" ||
          response?.account_status === "pin_reset_required";
        if (isLocked) {
          await handleLogoutInDB(navigate);
          navigate("/", { state: { isLockedAccount: true, phoneNumber: tempPhone } })
          return;
        }
        if (response.message) {
          setError(
            response.attempts_left
              ? `${response.message} (${response.attempts_left} ${I18n.tries_left})`
              : response.message,
          );
        }
      }
    } catch {
      setLoading(false);
      const errData = error?.response?.data;
      const isLocked =
        error?.response?.status === 429 ||
        errData?.is_locked ||
        errData?.account_status === "locked" ||
        errData?.account_status === "suspended" ||
        errData?.account_status === "pin_reset_required";
      if (isLocked) {
        await handleLogoutInDB(navigate);
        navigate("/", { state: { isLockedAccount: true, phoneNumber: tempPhone } })
      }
    }
  };

  const handleSetPINSuccess = () => {
    setIsCreate(false);
    setVerifyPINScreen(false);
    setIsActivatedScreen(true);
    setIsPinUpdatedSuccessfully(true);
    setPIN("");
    setError("");
  };

  const handleChangePIN = () => {
    triggerLogEvent(analytics, "setting_pin_change", {});
    setVerifyPINScreen(true);
  };

  const isNonIdeal =
    !checkPINloading &&
    !errorCheckPin &&
    !isPinUpdatedSuccessfully &&
    !verifyPINScreen &&
    !isCreate &&
    !isAcivatedScreen;

  const showChangePinAction =
    isAcivatedScreen &&
    !verifyPINScreen &&
    !isCreate &&
    !isPinUpdatedSuccessfully &&
    !checkPINloading &&
    !errorCheckPin;

  const renderPinContent = () => {
    if (checkPINloading) return null;

    if (errorCheckPin) {
      return (
        <UBButton
          title={I18n.retry}
          id="retry_btn"
          className="ubPrimaryButton fontSize14 fontWeight400 textUppercase"
          onClick={handleCheckIsSetPin}
        />
      );
    }

    if (isPinUpdatedSuccessfully) {
      return (
        <SuccessfullyUpdatePin
          handleReset={() => setIsPinUpdatedSuccessfully(false)}
        />
      );
    }

    if (verifyPINScreen) {
      return (
        <Box className={styles.pinScreenWrapper}>
          <PINScreen
            error={error}
            title={I18n.enter_current_pin}
            description={I18n.we_need_your_current_pin_to_proceed}
            onChangeQuery={getPIN}
            id="setup_pin"
          />
        </Box>
      );
    }

    if (isCreate) {
      return (
        <Box className={styles.pinScreenWrapper}>
          <CreatePin
            oldPIN={PIN}
            handleSetPINSuccess={handleSetPINSuccess}
            handleCancel={cancelCreatePin}
            isHeader={false}
            isOnboarding={false}
          />
        </Box>
      );
    }

    if (isAcivatedScreen) {
      return <ActivatedPinCode handleChangePIN={handleChangePIN} />;
    }

    return null;
  };

  return (
    <MainContainer fluid className={styles.pinPage}>
      <BusinessLoader loadBusiness={loading || checkPINloading} />
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              id: "pincode",
              title: I18n.pin_code,
              className: styles.pinPageTitle,
            }}
          >
          </TitleAndActionBox>
          <InnerWrapper className={`innerWrapper newInnerWrapper ${styles.pinPageSurface}`}>
            {isNonIdeal ? (
              <NonIdealNew
                title={I18n.create_your_pin}
                subtitle={I18n.setup_pin_security}
                button1Title="create_pin"
                onButton1Click={() => setIsCreate(true)}
                loading={false}
                disabledOne={false}
                buttonOneId="create_pin"
                mainIcon={<SetupPIn />}
              />
            ) : (
              renderPinContent()
            )}
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default SetupPin;
